import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

class Footer extends Component {
  constructor() {
    super()
  }

  render() {
    return (
      <div style={{left:0,bottom:0,right:0,display:'flex', alignItems:'center',
        justifyContent:'space-between',backgroundColor:'black', height:'50px'}}>
        <div style={{display: 'block',marginLeft:'10px', color:'green',fontFamily: 'Raleway'}}>
          Bailey's Buds LLC
        </div>
        <NavLink to='/info/settings' href="#top"
          style={{marginRight:'5vw'}}>
          <div style={{display: 'block',marginLeft:'10px', color:'green',
            fontFamily: 'Raleway'}}>
            Go To My Settings
          </div>
        </NavLink>
      </div>
    );
  }
}

export default Footer
